import { Alert, Platform } from "react-native";
import { PromptOpts } from "./ConfirmDialog.types";

export function useConfirmDialog() {
  const prompt = (options: PromptOpts) => {
    if (Platform.OS == "web") {
      const response = confirm(options.message);
      if (response && options.onYes) {
        options.onYes();
      } else if (!response && options.onNo) {
        options.onNo();
      }
    } else {
      Alert.alert(options.title, options.message, [
        { text: "No", onPress: options.onNo },
        { text: "Yes", onPress: options.onYes },
      ]);
    }
  };

  return { prompt };
}
